var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_252_87623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 19C7 12.3726 12.3726 7 19 7C25.6274 7 31 12.3726 31 19C31 25.6274 25.6274 31 19 31C12.3726 31 7 25.6274 7 19Z",
    fill: "#516CD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 19C7 12.3726 12.3726 7 19 7C25.6274 7 31 12.3726 31 19C31 25.6274 25.6274 31 19 31C12.3726 31 7 25.6274 7 19Z",
    fill: "url(#paint0_radial_252_87623)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 19C7 12.3726 12.3726 7 19 7C25.6274 7 31 12.3726 31 19C31 25.6274 25.6274 31 19 31C12.3726 31 7 25.6274 7 19Z",
    fill: "url(#paint1_radial_252_87623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 6.5C12.0964 6.5 6.5 12.0964 6.5 19C6.5 25.9036 12.0964 31.5 19 31.5C25.9036 31.5 31.5 25.9036 31.5 19C31.5 12.0964 25.9036 6.5 19 6.5Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6 14H24.4C24.7314 14 25 14.2487 25 14.5556V23.4444C25 23.7513 24.7314 24 24.4 24H13.6C13.2686 24 13 23.7513 13 23.4444V14.5556C13 14.2487 13.2686 14 13.6 14ZM23.8 16.3544L19.0431 20.2989L14.2 16.3422V22.8889H23.8V16.3544ZM14.5069 15.1111L19.0371 18.8122L23.5006 15.1111H14.5069Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_252_87623",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_252_87623"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_252_87623",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_252_87623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.3333 12) rotate(51.0441) scale(20.1467 20.1467)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_252_87623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.7123 28) rotate(-93.6705) scale(20.5421 22.8951)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34499C",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#516CD3",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861815,
    stopColor: "#516CD3",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOption);
export default __webpack_public_path__ + "static/media/EmailOption.82f9cc3e1a29779ffba1adae549629e0.svg";
export { ForwardRef as ReactComponent };